import type { AuditEntry } from '../api/types.js';

/** Renders the `after` context compactly — the approved command, or key/values. */
function detail(after: unknown): string {
  if (!after || typeof after !== 'object') return '';
  const a = after as Record<string, unknown>;
  if (typeof a.command === 'string') return a.command;
  return Object.entries(a)
    .filter(([, v]) => v !== null && v !== undefined && v !== '')
    .map(([k, v]) => `${k}: ${typeof v === 'string' ? v : JSON.stringify(v)}`)
    .join(' · ');
}

/** The audit table, shared by the global audit page and the per-project view. */
export function AuditTable({ entries }: { entries: AuditEntry[] }) {
  if (entries.length === 0) return <p className="opacity-70">No activity recorded yet.</p>;
  return (
    <div className="overflow-x-auto">
      <table className="w-full text-sm">
        <thead>
          <tr className="border-b border-secondary/10 text-left opacity-60">
            <th className="py-2 pr-4 font-medium">When</th>
            <th className="py-2 pr-4 font-medium">Who</th>
            <th className="py-2 pr-4 font-medium">Action</th>
            <th className="py-2 pr-4 font-medium">Subject</th>
            <th className="py-2 font-medium">Details</th>
          </tr>
        </thead>
        <tbody>
          {entries.map((e) => (
            <tr key={e.id} className="border-b border-secondary/5 align-top">
              <td className="whitespace-nowrap py-2 pr-4 opacity-70">
                {new Date(e.createdAt).toLocaleString()}
              </td>
              <td className="py-2 pr-4">{e.actorEmail ?? 'system'}</td>
              <td className="py-2 pr-4 font-mono text-xs">{e.action}</td>
              <td className="py-2 pr-4 opacity-70">
                {e.subjectType}
                {e.subjectId ? ` · ${e.subjectId.slice(0, 8)}` : ''}
              </td>
              <td className="max-w-xs break-words py-2 font-mono text-xs opacity-70">
                {detail(e.after)}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
